<template>
    <div id="editAccessStore">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <!-- <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col> -->
        </el-row>
        <el-col class="fl searthPart">
            <el-form label-width="100px" :inline="true" :label-position="labelPosition">
                <el-form-item label="出入库类型:" prop="StoreClass">
                    <el-select disabled @change="pickingChange" v-model="searchForm.inbound_type" placeholder="请选择出入仓库" style="width: 100%;">
                        <el-option v-for="(item,index) in pickingType" 
                            :label="item.paraName" 
                            :value="item.paraCode" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出入库仓库:" prop="accessStore">
                    <el-select v-model="searchForm.warehouseType" placeholder="请选择出入仓库" style="width: 100%;" disabled clearable>
                        <el-option v-for="(item,index) in pickingList" 
                            :label="item.paraName" 
                            :value="item.paraCode" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商:" prop="accessStore">
                    <el-select v-model="searchForm.supplierId" @change="changeSupplierId" :filter-method="PinyinMatch1" placeholder="请选择供应商" style="width: 100%;" clearable filterable>
                        <el-option v-for="(item,index) in pickingSurply" 
                            :label="item.paraName" 
                            :value="item.paraCode" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注信息:">
                    <el-input clearable type="textarea" v-model.trim="searchForm.memo" placeholder="请输入备注信息"></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr">
            <otherAccess v-if="searchForm.inbound_type == 'QTRK'" :searchForm="searchForm"></otherAccess>
            <materialAccess  v-if="searchForm.inbound_type == 'WLCK'" :searchForm="searchForm"></materialAccess>
            <purchaseAccess  v-if="searchForm.inbound_type == 'CGRK'" :searchForm="searchForm"></purchaseAccess>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard';
    import PinyinMatch from 'pinyin-match';
    import {
        selectParameterInfoBusiness,
        purchaseOrdersClose,
        selectAllBrand,
        selectCategory,
        selectModel,
        selectMaterialManagements,
        getMaterialList,
        getsupplierList,
        inboundDetails
    } from "../../api/api";
    import otherAccess from '@/components/editAccessStore/otherAccess'
    import materialAccess from '@/components/editAccessStore/materialAccess'
    import purchaseAccess from '@/components/editAccessStore/purchaseAccess'
    export default {
        name: 'editAccessStore',
        components: {
            otherAccess,
            materialAccess,
            purchaseAccess
        },
        data () {
            return {
                copy1:[],
                labelPosition:'left',
                pickingList:[], //出入仓库列表
                pickingType:[], //出入库类型列表
                pickingSurply:[],//供应商
                searchForm:{
                    inbound_type:'QTRK',   //出入库类型
                    warehouseType:'',      //出入库仓库
                    memo:'',               //备注信息
                    dislogMater:false,
                    code:'',               //采购订单编号
                    orderId:'',            //订单详情ID
                    attribute1:'',         //物料序列号字符串
                    supplierId:''
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 50,
                },
                orderId:'',
                type:'',
                warehouseType:'',
                returnForm:{}
            }
        },
        mounted () {
            
        },
        created(){
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.orderId) {
                let userOrderId = sessionStorage.getItem('saveOrderId');
                this.orderId = JSON.parse(userOrderId);
                this.searchForm.orderId = this.orderId;
            }else{
                this.orderId = this.$route.query.orderId;
                this.searchForm.orderId = this.$route.query.orderId;
            }
            this.getInboundDetails();     //获取出入库信息
            this.getSupplierListData();
            this.getSelectParameterInfoBusiness();
            this.getSelectParameterInfoBusinessType();
        },
        methods: {
            //获取订单详情
            getInboundDetails() {
                let para={
                    id: this.orderId,
                }
                inboundDetails(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnForm = res.data.results.inboundInfo;
                        this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime)
                        sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.inboundInfo.id));
                        if(this.returnForm.type == '其他入库'){
                            this.searchForm.inbound_type = 'QTRK';
                        }else if(this.returnForm.type == '采购入库'){
                            this.searchForm.inbound_type = 'CGRK';
                        }else if(this.returnForm.type == '物料出库'){
                            this.searchForm.inbound_type = 'WLCK';
                        }
                        if(this.returnForm.warehouseType == '良品仓'){
                            this.searchForm.warehouseType = "LPC"
                        }else if(this.returnForm.warehouseType == '售前仓'){
                            this.searchForm.warehouseType = "SQC"
                        }else if(this.returnForm.warehouseType == '废宝仓'){
                            this.searchForm.warehouseType = "FBC"
                        }else if(this.returnForm.warehouseType == '售后仓'){
                            this.searchForm.warehouseType = "SHC"
                        }else if(this.returnForm.warehouseType == '废品仓'){
                            this.searchForm.warehouseType = "FPC"
                        }
                        this.searchForm.supplierId = this.returnForm.supplierId;
                        this.searchForm.memo = this.returnForm.memo;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //强制刷新
            changeSupplierId(e){
                this.searchForm.supplierId = e;
                this.$forceUpdate();
            },
            //供应商拼音模糊搜索
            PinyinMatch1(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy1.forEach(i => {
                        let m = PinyinMatch.match(i.paraName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.supplierId = val;
                    this.pickingSurply = result;
                }else{
                    this.pickingSurply = this.copy1;
                    this.searchForm.supplierId = "";
                }
            },
            pickingChange(e){
                if(e == null || e == ""){
                    this.searchForm.inbound_type = 'QTRK'
                }
                if(e == 'CGRK'){
                    this.searchForm.warehouseType = 'LPC'
                }
            },
            getPurchaseCode(data){
                this.searchForm.code = data.code
                this.searchForm.orderId = data.orderId
            },
            //获取出入仓库列表
            getSelectParameterInfoBusiness(){
                let para={
                    paraType: 'warehouse_type'
                }
                selectParameterInfoBusiness(para).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingList = res.data.results.list          
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取出入仓库类型
            getSelectParameterInfoBusinessType(){
                let para={
                    paraType: 'inbound_type'
                }
                selectParameterInfoBusiness(para).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingType = [];
                        if(res.data.results.list.length > 0){
                            res.data.results.list.forEach((item,index)=>{
                                this.pickingType.push(item)
                            })   
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取供应商下拉列表
            getSupplierListData(){
                getsupplierList({startRow:1,pageSize:10000}).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingSurply = res.data.results.list
                        this.pickingSurply.forEach((item,index)=>{
                            item.paraName = item.supplierName
                            item.paraCode = item.id
                        })
                        this.copy1 = Object.assign(this.pickingSurply); //保留数据源          
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/accessStoreManage'
                })
            },
            searchPurchaseOrder(){
                this.$refs.childComponent.newMater()
            },
            //导入采购数据
            exportPurchase(){
                if(this.searchForm.code == ''){
                    this.$message({
                        message: '请输入采购订单编号',
                        type: "warning"
                    });
                }else{
                    this.$refs.childComponent.getPurchaseOrdersInfo();
                } 
            },
            refresh() {
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.inbound_type = 'QTRK';   //出入库类型
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
                ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            }
        }
    }
</script>

<style type="text/css" lang="scss" scoped>
  #editAccessStore{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .headerT{font-size: 16px;margin:20px 0 15px 0;}
    .headerSpan{margin-right: 20px;}
    .listPart{border:1px solid #c6c6c6;margin:-8px 15px 10px 0;border-radius: 5px;text-align: center;position: relative;z-index: 0;cursor: pointer;padding: 5px 10px;}
    li.active{background-color:#1abc9c;color:#fff;border-color: #1abc9c;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    .el-step__icon.is-text{border-color: #1abc9c;}
    .totalDiv{
      height: auto;
      overflow: hidden;
      text-align: right;
      font-size: 16px;
      background-color: #fff;
      border-bottom: 1px solid #e5e9f2;
      padding: 10px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// editAccessStore.vue?815783ae